import { mapGetters, mapMutations, mapState } from 'vuex';
import mainViewMixin from '../mainViewMixin';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { EventBus } from '@/services/eventbus.js';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'ViewNiotaClassicApplicationsApplicationDetails',
  mixins: [mainViewMixin],
  data: function () {
    return {
      tabItem: 'tab-details',
      applicationObject: {},
      applicationCanBeEdited: true,
      migrateDialog: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    // the migration ships hidden behind IOT_HUB_MIGRATION_ENABLED until the end-of-life communication
    isMigrationAvailable() {
      return this.isFeatureFlagEnabled('env_iot_hub_migration_enabled') && this.isFeatureFlagEnabled('env_n1_enabled');
    },
    canMigrate() {
      return this.isMigrationAvailable && Boolean(this.permissions['IotHub.read'] || this.permissions['IotHub.manage']) && Boolean(this.permissions['VirtualDevice.manage']);
    }
  },
  watch: {
    $route() {
      this.getApplication(this.$route.params.applicationId);
    }
  },
  created() {
    this.getApplication(this.$route.params.applicationId);
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    breadCrumbsPath() {
      if (get(this, 'applicationObject.account.name') && get(this, 'applicationObject.title')) {
        return [this.permissions['all.manage'] ? {
          text: this.applicationObject.account.name,
          to: `/account-mgmt/${this.applicationObject.account.id}`
        } : this.applicationObject.account.name, this.applicationObject.title];
      }
      return [];
    },
    addressSelected(addressData) {
      let tmp = get(addressData, 'address.formatted_address');
      if (tmp) {
        set(this.applicationObject, 'data.address', {});
        this.applicationObject.data.address.formatted_address = tmp;
      }
      this.applicationObject.coordinates = {
        coordinates: addressData.coordinates
      };
      this.applicationObject = cloneDeep(this.applicationObject);
    },
    prepareSubmit() {
      this.handleSubmit();
    },
    getApplication(applicationId) {
      return NiotaClassicApiService.applicationGet(applicationId).then(res => {
        this.applicationObject = res.data.application;
        EventBus.$emit('update-breadcrumbs');
      });
    },
    viewAllApplications() {
      this.$router.push({
        path: '/niota-classic/applications'
      });
    },
    onMigrationStarted(runner) {
      this.migrateDialog = false;
      if (runner && runner.id) {
        this.$router.push({
          path: '/background-jobs',
          query: {
            tab: 'bg-jobs-import',
            openRunnerId: runner.id
          }
        });
      }
    },
    updateItem(item) {
      this.applicationObject = cloneDeep(item);
    },
    getImageUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }
      return `${location.origin}${image}`;
    }
  }
};